import { render, staticRenderFns } from "./FormPart8.vue?vue&type=template&id=0ce38cd7&scoped=true"
import script from "./FormPart8.vue?vue&type=script&lang=js"
export * from "./FormPart8.vue?vue&type=script&lang=js"
import style0 from "./FormPart8.vue?vue&type=style&index=0&id=0ce38cd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce38cd7",
  null
  
)

export default component.exports